import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * A utility function for constructing class names with conditional logic
 * and proper merging of Tailwind CSS classes.
 *
 * @example
 * // Basic usage
 * cn('text-red-500', 'bg-cic-blue-200')
 *
 * @example
 * // With conditional classes
 * cn('text-lg', isActive && 'font-bold', isBig ? 'p-4' : 'p-2')
 *
 * @example
 * // With class object syntax
 * cn({ 'bg-blue-500': isBlue, 'bg-red-500': !isBlue })
 */
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
